<as-split class="listing" direction="horizontal" [gutterSize]="18">
  <as-split-area [size]="70">

    <div class="table-container">
      <div>
        <button mat-raised-button color="primary" class="icon-button" (click)="addNewUser()">
          <mat-icon svgIcon="plus" class="button-icon"></mat-icon>
          <span>Add User</span>
        </button>
      </div>
      <br>
      <table role="grid" class="mat-elevation-z8 mood-table">
        <thead>
          <tr>
            <th>Login</th>
            <th>Email</th>
            <th>Name</th>
            <th>Active</th>
            <th>Admin</th>
            <th>Registered since</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of userList">
            <td>{{ user.login }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.firstname }} {{ user.surname }}</td>
            <td>{{ user.disabled ? 'Inactive' : 'Yes' }}</td>
            <td>{{ user.isadmin ? 'Yes' : 'No' }}</td>
            <td>{{ user.registered_on | date : 'longDate' }}</td>
            <td>
              <button mat-icon-button (click)="toggleUserEdit(user)">
                <mat-icon svgIcon="account-edit"></mat-icon>
              </button>

              <button mat-icon-button (click)="resetUserPassword(user)">
                <mat-icon svgIcon="lock-reset"></mat-icon>
              </button>
            </td>
            <!-- <ng-container -->
            <!-- *ngTemplateOutlet="currentUserEditing === user.id ? userEditTemplate : userViewTemplate; context: { $implicit: user }"></ng-container> -->
          </tr>
        </tbody>
      </table>
    </div>

  </as-split-area>

  <as-split-area [size]="30" *ngIf="currentUserEditing">
    <mood-user-form-admin [userId]="currentUserEditing" (userSavedEmitter)="onCloseEvent($event)"></mood-user-form-admin>
  </as-split-area>
</as-split>

